import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { GetUserById, isGuestOrPremiumUser } from "../settings/actions";
import CheckoutB from "./component";
import {
  createPaymentIntent,
  doCheckOut,
  createWalletPaymentIntent,
  userMetaDetails,
} from "../checkout/actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createPaymentIntentConnect: createPaymentIntent,
      doCheckOutConnect: doCheckOut,
      GetUserByIdConnect: GetUserById,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      createWalletPaymentIntentConnect: createWalletPaymentIntent,
      userMetaConnect: userMetaDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutB);
